import { GuidedDraggingTool } from '@y42/gojs';
import { Diagram, GraphObject, Link, Margin, Node, TreeLayout } from 'gojs';
import { orchestrationDiagramConfig } from './config/orchestration-diagram.config';
import { LinkTemplateMap } from './templates/link/link';
import { NodeTemplateMap } from './templates/nodes/default-node';
import { createTemplateMap } from './utils/create-template-map';
import {
  OrchestrationGoJsCommandHandleInjector,
  OrchestrationGoJsCommandHandler,
} from './utils/orchestration-gojs-command-handler';

const $ = GraphObject.make;

const TreeLayoutConfig = { layerSpacing: 150, nodeSpacing: 50 };

export const OrchestrationDiagram = (injector: OrchestrationGoJsCommandHandleInjector): Diagram => {
  const diagram = $(Diagram, {
    padding: new Margin(30),
    scale: orchestrationDiagramConfig.defaultScale,
    validCycle: Diagram.CycleNotDirected,
    scrollMode: Diagram.InfiniteScroll,
    linkTemplateMap: createTemplateMap<Link>(LinkTemplateMap()),
    nodeTemplateMap: createTemplateMap<Node>(NodeTemplateMap()),
    layout: $(TreeLayout, TreeLayoutConfig),
    draggingTool: $(GuidedDraggingTool, {
      isComplexRoutingRealtime: false,
      guidelineWidth: 1,
      isGuidelineEnabled: false,
    }),
  });

  diagram.animationManager.duration = 500;
  diagram.toolManager.hoverDelay = 10;
  diagram.toolManager.toolTipDuration = 10000;

  diagram.commandHandler = new OrchestrationGoJsCommandHandler(injector);

  return diagram;
};
